module.exports = __webpack_public_path__ + "static/images/classpass.56c541cb5119c2f16a50083b5bf7bf13.svg";